<script lang="ts" setup>
defineProps<{
  feed: Feed.Info
}>()

const { scrollBottom } = useScrollState()

function goToComment() {
  const el = document.getElementById('comment')
  if (el) {
    window.scrollTo({
      top: el.offsetTop - 64,
      behavior: 'smooth'
    })
  }
}
</script>

<template>
  <div class="m-feed-side-action">
    <div class="m-feed-side-action-item">
      <m-like-action
        :resource-id="feed.id"
        :resource-type="3"
        :like-status="feed.like_status"
        type="like"
        vertical
      >
        <span class="text">
          {{ pipe.num(feed.like_status.like.count) || '喜欢' }}
        </span>
      </m-like-action>
    </div>
    <div class="m-feed-side-action-item">
      <m-like-action
        :resource-id="feed.id"
        :resource-type="3"
        :like-status="feed.like_status"
        type="dislike"
        vertical
      >
        <span class="text">
          {{ pipe.num(feed.like_status.dislike.count) || '不喜欢' }}
        </span>
      </m-like-action>
    </div>
    <div class="m-feed-side-action-item" @click="goToComment">
      <m-icon icon="ni ni-comment" vertical>
        <span class="text">
          {{ pipe.num(feed.floor_num) || '评论' }}
        </span>
      </m-icon>
    </div>
    <div class="m-feed-side-action-item">
      <m-forward-action :resource-id="feed.id" :resource-type="3" vertical>
        <span class="text">转发</span>
      </m-forward-action>
    </div>
    <div class="m-feed-side-action-item">
      <m-report-action :resource-id="feed.id" :resource-type="3" vertical>
        <span class="text">举报</span>
      </m-report-action>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.m-feed-side-action {
  position: fixed;
  margin-left: -75px;
  top: 92px;
  color: var(--color-gray-400);
  &-item {
    padding: 8px;
    background-color: #fff;
    border-radius: 4px;
    width: 64px;
    height: 64px;
    margin-bottom: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    .m-icon {
      font-size: 24px;
      cursor: pointer;
    }
    .text {
      margin-top: 8px;
      font-size: 12px;
    }
  }
}
</style>
